<script lang="ts">
    import type {OverlappingJobs} from "../overlappingJobs.svelte";
    import {type PageStateAny} from "../state";
    import type {Job, Site, User} from "../types";
    import type {ZoomRangeWithBlocks} from "../zoom2.svelte.js";
    import {getOverlappingHeight} from "../lib";

    type Props = {
        sites: Site[];
        overlappingJobs: OverlappingJobs;
        pageState: PageStateAny;
        rowStepPx: number;
        zoom: ZoomRangeWithBlocks;
    };
    let {
        sites,
        overlappingJobs,
        pageState,
        rowStepPx,
        zoom,
    }: Props = $props();

    const getRowHeight = (user: User) => {
        let overlappingHeight = getOverlappingHeight(
            user,
            overlappingJobs,
        );
        return rowStepPx * overlappingHeight;
    };

    const getUsersAvailability = (
        item: Job,
        sites: Site[],
        zoom: ZoomRangeWithBlocks,
    ) => {
        const toReturn: {
            height: number;
            top: number;
            width: number | null;
            left: number;
            valid: boolean;
            site_id: string;
        }[] = [];
        let prevTop = 0;
        for (const site of sites) {
            let height = getRowHeight(site);
            toReturn.push({
                height: height,
                top: prevTop,
                width: null,
                left: 0,
                valid: true,
                site_id: site.id,
            });
            prevTop += height;
        }
        return toReturn;
    };
    let availableUsers = $derived(
        pageState?.selected
            ? getUsersAvailability(pageState.selected.item, sites, zoom)
            : [],
    );
</script>

<div class="rows">
    {#each sites as site}
        <div
            class="row"
            style:height={`${getRowHeight(site)}px`}
        ></div>
    {/each}
</div>

<style lang="scss">
    .rows {
        position: relative;
    }

    .row {
        height: var(--height);
        border-bottom: solid 1px var(--border);
        background: var(--background);

        &:nth-child(odd) {
            background: var(--muted);
        }

        transition: background 100ms,
        height 200ms;
        transition-delay: 80ms;
    }
</style>
